<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";
import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";

import ListingTable from "@/components/listings/listing-table";

export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        ListingTable,
        InputGroup,
        SelectGroup
    },
    data() {
        return {
            title: "Report",
            items: [
                {
                    text: "Report"
                },
            ],
            filter: {
                branch: '',
                product: '',
                staff: '',
                from_date: '',
                to_date: '',
                status: 'completed',
            },
            fields: [
                { key: 'id', label: 'ID' },
                { key: 'order_id', label: 'Booking ID' },
                { key: 'shopify_id', label: 'Shopify Order ID' },
                { key: "booking_date", label: 'Booking Date' },
                { key: "customer_name", label: 'Customer Name' },
                { key: "customer_email", label: 'Customer Email' },
                { key: "staff_id", label: 'Staff ID' },
                { key: "staff_name", label: 'Staff Name' },
                { key: "sku", label: "SKU" },
                { key: "product_name", label: "Treatment" },
                { key: "product_duration", label: "Duration" },
                { key: "category_id", label: "Category" },
                { key: "branch_id", label: "Branch" },
                { key: "total", label: "Price" },
                { key: "commission", label: "Commission" },
            ],
            branchOptions: [],
            productOptions: [],
            therapistOptions: [],
        };
    },
    computed: {

    },
    watch: {

    },
    async mounted() {
        this.retrieveBranches().then((branches) => {
            this.branchOptions = branches.map((branch) => ({
                name: branch.name,
                value: branch.id,
            }));
        });

        this.retrieveProducts().then((products) => {
            const productArray = Object.values(products);
            this.productOptions = productArray.map((product) => ({
                name: product.description.name,
                value: product.shopify_product_id,
            }));
        });

        this.retrieveStaffs().then((staffs) => {
            this.therapistOptions = staffs.map((staff) => ({
                name: staff.name,
                value: staff.id,
            }));
        });
    },
    methods: {
        async retrieveBranches() {
            this.loading = true;
            let branches = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/branch`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    branches = result['data'].branches;
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return branches;
        },

        async retrieveProducts() {
            this.loading = true;
            let products = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/all-product`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    products = result['data'].products;
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return products;
        },        

        async retrieveStaffs() {
            this.loading = true;
            let staffs = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/staff`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    staffs = result['data'].staffs;
                }
            } catch (e) {
                console.error('Error fetching staffs: ' + e);
            }

            this.loading = false;
            return staffs;
        },

        setAdminView(filter) {
            this.filter = Object.assign(this.filter, filter);
        },

        filterTable() {
            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        },

        resetFilter() {
            this.filter = {
                branch: '',
                product: '',
                staff: '',
                from_date: '',
                to_date: '',
            };

            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        },

        exportTable() {
            try {
                axios.get(`${process.env.VUE_APP_APIURL}/report/export`, {
                    headers: authHeader(),
                    responseType: 'blob',
                    params: {
                        filter: this.filter,
                    },
                })
                .then(response => {
                    if (response.status === 200) {
                        const blob = new Blob([response.data], { type: 'text/csv' });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = 'report-' + new Date().toISOString().slice(0, 10) + '.csv';
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                });
            } catch (e) {
                console.error('Error exporting report: ' + e);
            }
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-4 col-lg-3 mt-2">
                                <SelectGroup id="filter_branch" displayName="Branch" :options="branchOptions" v-model="filter.branch" />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3 mt-2">
                                <SelectGroup id="filter_product" displayName="Treament" :options="productOptions" v-model="filter.product" />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3 mt-2">
                                <SelectGroup id="filter_staff" displayName="Staff" :options="therapistOptions" v-model="filter.staff" />
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-sm-12 col-md-4 col-lg-3 mt-2">
                                <InputGroup id="filter_from_date" type="date" displayName="From Date" v-model="filter.from_date" />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3 mt-2">
                                <InputGroup id="filter_to_date" type="date" displayName="To Date" v-model="filter.to_date" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <a href="javascript:void(0);" class="btn btn-danger mt-2" @click="resetFilter">
                                    Reset
                                </a>
                                <a href="javascript:void(0);" class="btn btn-success mt-2 ml-2" @click="filterTable">
                                    Filter
                                </a>
                                <a class="btn btn-success mt-2 ml-2" @click="exportTable">
                                    Export
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="pl-4 pr-4">
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="order" listName="orders" from="report">
                            <template v-slot:cell(total)="{ item }">
                                <b>{{ item.total.toFixed(2) }}</b>
                            </template>
                            <template v-slot:cell(commission)="{ item }">
                                <b>{{ item.commission.toFixed(2) }}</b>
                            </template>
                        </ListingTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>